// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { isFirmFromPoi } from "~/util/review";
import { _ } from "~/i18n";
import { store } from '~/state/store';

/**
 * @class Vytváří položku obsahu vizitky - odkaz
 * @augments SMap.Detail.Content
 * @private
 */
 export default class Link extends Content {
	_build() {
		this._dom.container.classList.add("content-link");
		var d = this._data.value;

		// odkazy pro zbozi - chodi v jinem klici
		if (this._options.urls) {
			if (this._options.urls.zbozi) {
				if (!d) {
					d = [];
				}
				d.push({
					text: "www.zbozi.cz",
					url: this._options.urls.zbozi
				});
			}
		}

		if (!d || !d.length) { this._dom.container.classList.add("empty"); return; }

		if (d.length && this._data.label) {
			this._dom.container.innerHTML = "<strong>" + this._data.label + ":</strong>";
		}

		for (var i = 0; i < (d || []).length; i++) {
			var data = d[i];
			var link = document.createElement("a");
			link.href = data.url;
			link.setAttribute("target", "_blank");

			var text = data.text;

			if (!text) {
				var m = data.url.match(/\/\/([^\/\?\#]+)/);
				var domain = m && m.length >= 2 ? m[1] : data.url;
				text = _("moreInfo") + " " + domain;
			}

			if (data.url && data.url.match(/firmy\.cz/i)) {
				this._ec.push(JAK.Events.addListener(link, "click", this, "_firmStats"));
			}

			link.innerHTML = text;

			this._dom.container.appendChild(link);
		}
	}

	_firmStats() {
		const { data } = store.getState().detail;

		if (isFirmFromPoi(data)) {
			Mapy.getComponent("detail").sendFirmStats("firm", data, { placeId: 1, typeId: 7 });
		}
	}
};
